<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  return new MessageFormatter(props.content).formattedMessage;
});
</script>

<template>
  <!-- LINE stickers arrive as markdown images (alt "sticker-<id>"); show them at half their natural size. -->
  <span
    v-dompurify-html="formattedContent"
    class="prose prose-bubble [&_img[alt^='sticker-']]:[zoom:0.5]"
  />
</template>
